import { render } from "./shotAndWaterBody.vue?vue&type=template&id=2fe08673"
import script from "./shotAndWaterBody.vue?vue&type=script&lang=js"
export * from "./shotAndWaterBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__